import { render } from "./sector-detail.vue?vue&type=template&id=62bd580a&scoped=true"
import script from "./sector-detail.vue?vue&type=script&lang=js"
export * from "./sector-detail.vue?vue&type=script&lang=js"

import "./sector-detail.vue?vue&type=style&index=0&id=62bd580a&lang=scss"
import "./sector-detail.vue?vue&type=style&index=1&id=62bd580a&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bd580a"]])

export default __exports__